import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import AddEmploymentHistory from "../components/AddEmploymentHistory";

export default class EmploymentHistory extends Component {
  render() {
    const { onCancelClick, setToaster } = this.props;
    return (
      <div>
        <Switch>
          <Route
            exact
            path="/people/employees/dashboard/:EmployeeId/resume/5/setup"
            render={() => (
              <AddEmploymentHistory
                {...this.props}
                onCancelClick={onCancelClick}
                editMode={false}
                setToaster={setToaster}
              />
            )}
          />
          <Route
            path="/people/employees/dashboard/:EmployeeId/resume/5/:EmploymentHistoryId"
            render={() => (
              <AddEmploymentHistory
                {...this.props}
                onCancelClick={onCancelClick}
                editMode={true}
                setToaster={setToaster}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}
